// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl } from './index';
import { IPageParams, IPageResult, adaptPageParams, adaptPageResult } from './utils';

export async function fetchRoles(params?: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.roles}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function fetchPermissions(roleName = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.permissions}`, {
    method: 'GET',
    params: {
      roleName,
    },
  });
}

export async function updatePermission(roleName = '', data?: string[]) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.permissions}`, {
    method: 'PUT',
    params: {
      roleName,
    },
    data,
  });
}
